import { put } from 'redux-saga/effects'

import { fullPush, actions as configActions } from '~/config'

export default {

  takeLatest: ({ actions, workers }) => ({
    [actions.clickMenuItem]: workers.navigateWorker,
    [actions.logout]: workers.logoutWorker,
    [actions.changeLanguage]: workers.changeLanguageWorker,
  }),

  workers: {
    navigateWorker: function * (action) {
      const { url } = action.payload;

      yield put(fullPush(url));
    },

    logoutWorker: function * () {
      try {
        yield put(configActions.userLogout());
        // const result = yield apply(axios, axios.get, ['admin/logout/']);
        // yield put(fullPush('/login/'));
      } catch (e) {
        console.error(e);
      }
    },

    changeLanguageWorker: function * (action) {
      const { language } = action.payload;
      yield put(configActions.setUILanguage(language));
    }
  }
}
